import { Provider } from "mobx-react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import store from "./modules/emergency-sms/store";

const emergencyPublishQuestionAnswerStore = new store();

// ② Provider’a tam olarak inject()'te kullanacağınız anahtar ile verin
const stores = {
  EmergencyPublishQuestionAnswerStore: emergencyPublishQuestionAnswerStore,
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider {...stores}>
    <App />
  </Provider>
);
